module.exports = __webpack_public_path__ + "img/especialista.902845a9.png";